// ======================================================================
// File Name       : CourseRegisterEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { Button, Col, Form, InputGroup, Row, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import * as courseActions from '../../actions/CourseAction';
import * as ModalAction from '../../actions/ModalAction';
import * as containerActions from '../../actions/ContainerAction';
import DateTimeMinMax from '../../components/DateTimeMinMax';
import DateTimeWithValidate from '../../components/DateTimeWithValidate';
import { Category } from '../../components/Detail';
import FileUpload from '../../components/FileUpload';
import FormControlValidate from '../../components/FormControlValidate';
import { FormControl, Radio } from '../../components/formControl';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { DEFAULT_DATE_FORMAT, MODE, VALIDATE_TYPE } from '../../constants';
import {
  CERTIFICATE_USE_FLAG,
  CHOSEN_THUMBNAIL,
  END_CONDITION_TYPE_FOR_COURSE,
  END_CONDITION_TYPE_FOR_COURSE_LIST,
  PUBLIC_PERIOD_TYPE,
  REDIRECT_MODAL
} from '../../constants/CourseConstants';
import { HIDE_MESSAGE } from '../../constants/actionTypes/message';
import UserAttributeRegisterEditContainer from '../userAttribute/UserAttributeRegisterEditContainer';
import TableHead from '../../components/TableHead';
import * as ModalIds from '../../constants/ModalIds';
import { postContainerGetStructureByCourseSecernId } from '../../actions/httpRequests/container';
import * as courseUtils from '../../utils/CourseUtils';
class CourseRegisterEditContainer extends Component {
  constructor() {
    super();

    this.state = {
      detailSettingExpanded: false,
      userAttributeExpanded: false,
    };
    this.handleNextBtn = this.handleNextBtn.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleDetailSettingTitleClick = this.handleDetailSettingTitleClick.bind(this);
    this.handleUserAttributeTitleClick = this.handleUserAttributeTitleClick.bind(this);
    this.validation = this.validation.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.clearFileUpload = this.clearFileUpload.bind(this);
    this.handleImageFileSelectTypeChange = this.handleImageFileSelectTypeChange.bind(this);
  }

  handleNextBtn() {
    const { dispatch, modalId, course } = this.props;
    const imageFileSelectType = course.editingCourse.imageFileSelectType;
    if (this.validation()) {
      if (imageFileSelectType === CHOSEN_THUMBNAIL.DEFAULT) {
        dispatch(courseActions.getDefaultThumbnail());
      }
      dispatch(ModalAction.openModal(REDIRECT_MODAL[modalId].OK));
    }
  }

  handleInputChange(name, value) {
    const { dispatch } = this.props;
    let payLoad = { [name]: value };
    if (name === 'limitPublicPeriod' && value === PUBLIC_PERIOD_TYPE.NO_LIMIT) {
      payLoad = { [name]: value, publicPeriodFrom: '', publicPeriodTo: '' };
    } else if (name === 'endConditionTypeForCourse' && value !== END_CONDITION_TYPE_FOR_COURSE.PROGRESS) {
      dispatch(courseActions.handleInputChange({ progressRatioForCourseEnd: 0 }));
    }
    dispatch(courseActions.handleInputChange(payLoad));
  }

  handleImageFileSelectTypeChange(name, value) {
    const { dispatch, course } = this.props;
    const { imageFileSelectType } = course.editingCourse;
    dispatch(courseActions.handleInputChange({ [name]: value }));
    if (imageFileSelectType === CHOSEN_THUMBNAIL.MANUAL || imageFileSelectType === CHOSEN_THUMBNAIL.NOTHING) {
      this.clearFileUpload();
    }
  }

  handleDetailSettingTitleClick() {
    // Step 10.2.0 START
    const { dispatch, course: { detailSettingExpanded } } = this.props;
    dispatch(courseActions.saveDetailSettingState('detailSettingExpanded', !detailSettingExpanded));
    // Step 10.2.0 END
  }

  handleUserAttributeTitleClick() {
    // Step 10.2.0 START
    const { dispatch, course: { userAttributeExpanded } } = this.props;
    dispatch(courseActions.saveDetailSettingState('userAttributeExpanded', !userAttributeExpanded));
    // Step 10.2.0 END
  }

  getModalOptions() {
    return {
      title: '登録/変更内容を入力してください',
      footerBtns: null,
      dialogClassName: 'course-edit-user-dialog',
    };
  }

  handleFileChange(event) {
    try {
      if (event.target.files && event.target.files.length !== 0) {
        const reader = new FileReader();
        const imageUploadFileName = event.target.files[0].name;
        const imageUploadFile = event.target.files[0];
        const { dispatch } = this.props;
        dispatch(courseActions.handleInputChange({ imageUploadFile, imageUploadFileName }));
        reader.readAsDataURL(imageUploadFile);
        reader.onload = () => {
          const dataUrl = reader.result;
          dispatch(courseActions.handleInputChange({ dataUrl }));
        };
      }
    } catch (err) {
      console.log(err);
    }
  }

  clearFileUpload() {
    const imageUploadFileName = null;
    if (this.fileInput && this.fileInput.clearInput) {
      this.fileInput.clearInput();
    }
    const { dispatch } = this.props;
    dispatch(courseActions.handleInputChange({ imageUploadFile: null }));

    if (this.refsToValidate && this.refsToValidate.length) {
      this.refsToValidate.forEach((item) => {
        item.setState({ errorVisible: false });
      });
    }
    this.props.dispatch({
      type: HIDE_MESSAGE,
    });
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  // Step 10.2.0 START
  handleAddBtnClick() {
    const { dispatch, course: { editingCourse: { courseSecernId }} } = this.props;

    postContainerGetStructureByCourseSecernId(courseSecernId).then((res) => {
      dispatch(containerActions.getDataItemTree(res));
      dispatch(ModalAction.openModal(ModalIds.ITEM_TREE_CONTAINER));
    });
  }

  removeItemInDialog(index) {
    const { dispatch } = this.props;
    dispatch(containerActions.removeItemListRelation(index));
  }
  // Step 10.2.0 END

  render() {
    const { course, container } = this.props;
    const { editType, editingCourse, courseRelations, childItemSercernIdList, detailSettingExpanded, userAttributeExpanded } = course;
    const { structures, selectedItemList } = container;
    const {
      courseName,
      description,
      publicStatus,
      publicPeriodFrom,
      publicPeriodTo,
      endConditionTypeForCourse,
      limitPublicPeriod,
      imageFileSelectType,
      itemListForCourseEnd,
      courseSecernId,
      imageUploadFile,
      completionFlag,
      progressRatioForCourseEnd,
    } = editingCourse;
    this.refsToValidate = [];
    let fileName = '';
    if (editingCourse.imageUploadFile && editingCourse.imageUploadFile.name) {
      fileName = editingCourse.imageUploadFile.name;
    }
    let fileSize = 0;
    if (editingCourse.imageUploadFile && editingCourse.imageUploadFile.size) {
      fileSize = editingCourse.imageUploadFile.size;
    }
    const acceptTypes = 'image/*';
    // Step 10.2.0 START
    const isEnableCourseEndCondition = courseUtils.isEnableCourseEndCondition(endConditionTypeForCourse);
    const hasOldEndCondition =
      isEnableCourseEndCondition && endConditionTypeForCourse !== END_CONDITION_TYPE_FOR_COURSE.NONE;

    const thead = [
      { title: "コース表示名称", sortBy: null },
      { title: "親セクション名", sortBy: null },
      { title: "操作", sortBy: null, width: 110 },
    ];

    let dataTable = null;
    if (selectedItemList && selectedItemList.length) {
      dataTable = selectedItemList.map((cur, index) => {
        let itemName = '';
        let boxNameWithItem = '';
        let boxIdWithItem = '';
        if (
          structures.bySecernId[cur.itemSecernId] &&
          Object.keys(structures.bySecernId).length
        ) {
          itemName = structures.bySecernId[cur.itemSecernId].structureName;
          boxIdWithItem = structures.bySecernId[cur.itemSecernId].parentBoxSecernId;
          boxNameWithItem = structures.bySecernId[boxIdWithItem].structureName;
        }
        return (
          <tr key={index}>
            <td>{itemName}</td>
            <td>{boxNameWithItem}</td>
            <td className="text-center">
              <i
                role="button"
                onClick={this.removeItemInDialog.bind(this, index)}
                className="bi bi-trash margin-top-10"
              />
            </td>
          </tr>
        );
      });
    }
    // Step 10.2.0 END

    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <Form
          onSubmit={(e) => {
            e.preventDefault();
          }}
          className="form-horizontal"
        >
          <Category label="基本設定" />
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              コース名<span className="required">&nbsp;(※)</span>
            </Col>
            <Col sm={9} className='padding-right-15'>
              <FormControlValidate
                name="courseName"
                type="text"
                label="コース名"
                value={courseName || ''}
                onChange={(event) => {
                  if (event && event.target) {
                    const { name, value } = event.target;
                    this.handleInputChange(name, value);
                  }
                }}
                required
                ref={(ref) => {
                  if (ref) {
                    this.refsToValidate.push(ref);
                  }
                }}
              />
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              説明
            </Col>
            <Col sm={9} className='padding-right-15'>
              <FormControl
                name="description"
                maxLength="1024"
                value={description || ''}
                onChange={this.handleInputChange}
              />
            </Col>
          </Form.Group>

          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              公開ステータス
            </Col>
            <Col sm={9} className='padding-right-15'>
              <Form.Select
                name="publicStatus"
                value={publicStatus}
                onChange={(event) => {
                  if (event && event.target) {
                    const { name, value } = event.target;
                    this.handleInputChange(name, value);
                  }
                }}
              >
                <option value={0}>非公開</option>
                <option value={1}>公開</option>
              </Form.Select>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={3}>
              サムネイル画像
            </Col>
            <Col sm={9} className="padding-left-clear">
              {editType === MODE.EDIT_MODE && (
                <Col sm={4} className="padding-top-10">
                  <Radio
                    inline
                    className="padding-top-clear"
                    name="imageFileSelectType"
                    id={`imageFileSelectType-${CHOSEN_THUMBNAIL.NOTHING}`}
                    value={CHOSEN_THUMBNAIL.NOTHING}
                    checked={imageFileSelectType === CHOSEN_THUMBNAIL.NOTHING}
                    onChange={this.handleImageFileSelectTypeChange}
                    label="変更しない"
                  />
                </Col>
              )}
              <Col sm={4} className="padding-top-10">
                <Radio
                  inline
                  className="padding-top-clear"
                  name="imageFileSelectType"
                  id={`imageFileSelectType-${CHOSEN_THUMBNAIL.DEFAULT}`}
                  value={CHOSEN_THUMBNAIL.DEFAULT}
                  checked={imageFileSelectType === CHOSEN_THUMBNAIL.DEFAULT}
                  onChange={this.handleImageFileSelectTypeChange}
                  label={
                    editType === MODE.EDIT_MODE
                      ? "初期画像に変更"
                      : "初期画像で登録"
                  }
                />
              </Col>
              <Col sm={4} className="padding-top-10">
                <Radio
                  inline
                  className="padding-top-clear"
                  name="imageFileSelectType"
                  id={`imageFileSelectType-${CHOSEN_THUMBNAIL.MANUAL}`}
                  value={CHOSEN_THUMBNAIL.MANUAL}
                  checked={imageFileSelectType === CHOSEN_THUMBNAIL.MANUAL}
                  onChange={this.handleImageFileSelectTypeChange}
                  label="手動で画像を変更"
                />
              </Col>
            </Col>
          </Form.Group>
          <Form.Group
            className={this.props.course.editingCourse.imageFileSelectType === CHOSEN_THUMBNAIL.MANUAL
              ? 'form-info margin-top-10' : 'hidden-upload-file form-info'}
          >
              <Col sm={7} className="col-sm-offset-3">
                <FormControlValidate
                  label="サムネイル画像"
                  type="text"
                  name="imageUploadFile"
                  className="margin-bottom-10"
                  value={fileName || ''}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                      if (ref.value !== '') {
                        ref.validation();
                      }
                    }
                  }}
                  required={imageFileSelectType === CHOSEN_THUMBNAIL.MANUAL}
                  fileSize={fileSize}
                  validateType={VALIDATE_TYPE.THUMBNAIL_SIZE_AND_TYPE}
                />
              </Col>
              <Col sm={2}>
                <FileUpload
                  inputId={'upload-file-course'}
                  onChange={this.handleFileChange}
                  fileName={this.props.imageUploadFileName}
                  labelName="選択"
                  ref={(ref) => {
                    this.fileInput = ref;
                  }}
                  accept={acceptTypes}
                />
              </Col>
          </Form.Group>
          <Form.Group
            className={this.props.course.editingCourse.imageFileSelectType === CHOSEN_THUMBNAIL.MANUAL
                  ? 'form-info margin-top-10' : 'hidden-upload-file form-info'}
          >
            <Col sm={2} className="col-sm-offset-10 padding-left-15 padding-bottom-7">
              <Button
                variant="danger"
                disabled={fileName === ''}
                className="btn-96"
                onClick={this.clearFileUpload}
              >
                {'クリア'}
              </Button>
            </Col>
          </Form.Group>
          <Form.Group className="form-info">
            <Col as={Form.Label} sm={12} className="padding-left-5">
              <a
                role="presentation"
                className={detailSettingExpanded ? 'minute' : 'plus'}
                onClick={this.handleDetailSettingTitleClick}
              >
                詳細設定
              </a>
            </Col>
          </Form.Group>
          {detailSettingExpanded && (
            <div>
              {editType === MODE.EDIT_MODE && (
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3} className="padding-left-30">
                    コース完了条件
                  </Col>
                  {/* Step 10.2.0 START */}
                  <Col sm={9}>
                    <Col sm={9} className="padding-top-10">
                      <Radio
                        inline
                        name="endConditionTypeForCourse"
                        id={`endConditionTypeForCourse-${END_CONDITION_TYPE_FOR_COURSE.NONE}`}
                        value={END_CONDITION_TYPE_FOR_COURSE.NONE}
                        checked={endConditionTypeForCourse === END_CONDITION_TYPE_FOR_COURSE.NONE}
                        onChange={this.handleInputChange}
                        disabled={!isEnableCourseEndCondition}
                        label="なし"
                      />
                    </Col>
                    <Col sm={9} className="padding-top-10">
                      <Radio
                        inline
                        name="endConditionTypeForCourse"
                        id={`endConditionTypeForCourse-${END_CONDITION_TYPE_FOR_COURSE.AND}`}
                        value={END_CONDITION_TYPE_FOR_COURSE.AND}
                        checked={endConditionTypeForCourse === END_CONDITION_TYPE_FOR_COURSE.AND}
                        onChange={this.handleInputChange}
                        disabled={!isEnableCourseEndCondition}
                        label="指定されたコンテンツを全て完了"
                      />
                    </Col>
                    <Col sm={9} className="padding-top-10">
                      <Radio
                        inline
                        name="endConditionTypeForCourse"
                        id={`endConditionTypeForCourse-${END_CONDITION_TYPE_FOR_COURSE.OR}`}
                        value={END_CONDITION_TYPE_FOR_COURSE.OR}
                        checked={endConditionTypeForCourse === END_CONDITION_TYPE_FOR_COURSE.OR}
                        onChange={this.handleInputChange}
                        disabled={!isEnableCourseEndCondition}
                        label="指定されたコンテンツのいずれかを完了"
                      />
                    </Col>
                    <Col sm={6} className="padding-top-10">
                      <Radio
                        inline
                        name="endConditionTypeForCourse"
                        id={`endConditionTypeForCourse-${END_CONDITION_TYPE_FOR_COURSE.PROGRESS}`}
                        value={END_CONDITION_TYPE_FOR_COURSE.PROGRESS}
                        checked={endConditionTypeForCourse === END_CONDITION_TYPE_FOR_COURSE.PROGRESS}
                        onChange={this.handleInputChange}
                        disabled={!isEnableCourseEndCondition}
                        label="指定されたコンテンツの完了条件達成率"
                      />
                    </Col>
                    {endConditionTypeForCourse === END_CONDITION_TYPE_FOR_COURSE.PROGRESS && (
                      <Col sm={3} className="padding-top-10">
                        <InputGroup size="sm">
                          <FormControl
                            name="progressRatioForCourseEnd"
                            component="input"
                            type="number"
                            min={0}
                            max={100}
                            onChange={this.handleInputChange}
                            value={progressRatioForCourseEnd || 0}
                            disabled={!isEnableCourseEndCondition}
                          />
                          <InputGroup.Text>%</InputGroup.Text>
                        </InputGroup>
                      </Col>
                    )}
                  </Col>
                  {!isEnableCourseEndCondition && (
                    <Col sm={12} as={Form.Label} className="textColorRed">※ 新条件が適用されています。新レイアウトで設定を確認ください。</Col>
                  )}
                  {hasOldEndCondition && (
                    <>
                      <Col sm={12}>
                        <Col sm={3} className="padding-top-10 padding-left-right-clear">
                          <Button variant="primary" className="btn-96" onClick={this.handleAddBtnClick.bind(this)}>
                            追加
                          </Button>
                        </Col>
                      </Col>
                      <Col sm={12} className="margin-top-10">
                        <FormControlValidate
                          validateType={VALIDATE_TYPE.ITEM_COURSE_END}
                          value={selectedItemList || []}
                          ref={(ref) => {
                            if (ref) {
                              this.refsToValidate.push(ref);
                            }
                          }}
                        />
                      </Col>
                      <Col sm={12} className="margin-top-10">
                        <Table striped hover>
                          <thead>
                            <TableHead data={thead} />
                          </thead>
                          <tbody>{dataTable}</tbody>
                        </Table>
                      </Col>
                    </>
                  )}
                  {/* Step 10.2.0 END */}
                </Form.Group>
              )}
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3} className="padding-left-30">
                  公開期間
                </Col>
                <Col sm={9} className="padding-top-10">
                  <Radio
                    className="margin-left-30 padding-top-clear"
                    inline
                    name="limitPublicPeriod"
                    id={`limitPublicPeriod-${PUBLIC_PERIOD_TYPE.NO_LIMIT}`}
                    value={PUBLIC_PERIOD_TYPE.NO_LIMIT}
                    checked={limitPublicPeriod === PUBLIC_PERIOD_TYPE.NO_LIMIT}
                    onChange={this.handleInputChange}
                    label="無期限"
                  />
                  <Radio
                    className="margin-left-30 padding-top-clear"
                    inline
                    name="limitPublicPeriod"
                    id={`limitPublicPeriod-${PUBLIC_PERIOD_TYPE.LIMIT}`}
                    value={PUBLIC_PERIOD_TYPE.LIMIT}
                    checked={limitPublicPeriod === PUBLIC_PERIOD_TYPE.LIMIT}
                    onChange={this.handleInputChange}
                    label="公開日指定"
                  />
                </Col>
              </Form.Group>
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3} className="padding-left-30" />
                <Col sm={3}>
                  <DateTimeWithValidate
                    dateFormat={DEFAULT_DATE_FORMAT}
                    value={publicPeriodFrom}
                    onChange={mDate =>
                      this.handleInputChange('publicPeriodFrom', mDate)}
                    disabled={limitPublicPeriod !== PUBLIC_PERIOD_TYPE.LIMIT}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
                <Col sm={1} className="text-center" as={Form.Label}>
                  ～
                </Col>
                <Col sm={3}>
                  <DateTimeWithValidate
                    dateFormat={DEFAULT_DATE_FORMAT}
                    value={publicPeriodTo}
                    locale="ja"
                    onChange={mDate =>
                      this.handleInputChange('publicPeriodTo', mDate)}
                    disabled={limitPublicPeriod !== PUBLIC_PERIOD_TYPE.LIMIT}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                  />
                </Col>
              </Form.Group>
              <Col sm={12}>
                <DateTimeMinMax
                  dateFrom={publicPeriodFrom}
                  dateTo={publicPeriodTo}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
              </Col>
              <Form.Group className="form-info">
                <Col as={Form.Label} sm={3} className="padding-left-30">
                  修了証の利用
                </Col>
                <Col sm={3}>
                  <Form.Select
                    name="completionFlag"
                    value={completionFlag}
                    onChange={(event) => {
                      if (event && event.target) {
                        const { name, value } = event.target;
                        this.handleInputChange(name, value);
                      }
                    }}
                  >
                    <option value={CERTIFICATE_USE_FLAG.NO_USE}>利用なし</option>
                    <option value={CERTIFICATE_USE_FLAG.USE}>利用あり</option>
                  </Form.Select>
                </Col>
              </Form.Group>
              <Form.Group className="form-info" style={{ display: 'none' }} />
              <Form.Group className="form-info">
                <Col sm={12}>
                  <UserAttributeRegisterEditContainer
                    titleClass="padding-left-20"
                    leftClass="padding-left-45"
                    expanded={userAttributeExpanded}
                    onTitleClick={this.handleUserAttributeTitleClick}
                  />
                </Col>
              </Form.Group>
            </div>
          )}
          <Col sm={12} className="text-center padding-top-10">
            <Button variant="default" style={{ marginRight: '5px' }} onClick={this.props.hideModal} className="btn-96">
              {'キャンセル'}
            </Button>
            <Button variant="primary" className="btn-96" onClick={this.handleNextBtn}>
              {'次へ'}
            </Button>
          </Col>
        </Form>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { course, container } = state;
  return { course, container };
};
export default connect(mapStateToProps)(CourseRegisterEditContainer);
